import { C } from "@/lib/brand";

// Filter chip row used across the hooks/posts/faqs sub-pages. Renders
// a horizontal list of pill toggles; the selected one gets a peach
// background. Includes a "ALL" reset chip.
export default function FilterChips({ value, onChange, options, labelFor, testIdPrefix }) {
  const all = [{ value: "all", label: "ALL" }, ...options.map((o) => ({
    value: typeof o === "string" ? o : o.value,
    label: typeof o === "string" ? (labelFor ? labelFor(o) : o.toUpperCase()) : o.label,
  }))];
  return (
    <div
      data-testid={`${testIdPrefix}-chips`}
      className="no-scrollbar"
      style={{
        display: "flex",
        flexWrap: "wrap",
        gap: 8,
        overflowX: "auto",
      }}
    >
      {all.map((chip) => (
        <button
          key={chip.value}
          type="button"
          onClick={() => onChange(chip.value)}
          data-testid={`${testIdPrefix}-chip-${chip.value}`}
          style={{
            padding: "8px 14px",
            fontSize: 10,
            fontWeight: 800,
            letterSpacing: "0.2em",
            background: value === chip.value ? C.ink : "transparent",
            color: value === chip.value ? C.cream : C.ink,
            border: `1.5px solid ${C.ink}`,
            cursor: "pointer",
            whiteSpace: "nowrap",
          }}
        >
          {chip.label}
        </button>
      ))}
    </div>
  );
}
